<div [hidden]="!isActive">
  <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/components/vertical-tab/vertical-tab.component.html